import type { OmpRequest } from "@jti/rest-api-types";

import type { RestResponseType } from "../../Rest";
import { Rest } from "../../Rest";
import type { OmpApiContract } from "../OmpApi.types";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class OmpApiLegacy extends Rest implements OmpApiContract {
  constructor(
    baseUrl: string,
    protected tenantToken: string
  ) {
    super(baseUrl);
    this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
  }

  sendMessage(data: OmpRequest, type = "CONTACT"): Promise<RestResponseType> {
    const { collection_point_token, consent_purposes, channel, user, ...rest } = data;

    const requestBody = JSON.stringify({
      channel,
      user,
      collection_point_token,
      consent_purposes,
      ...(data?.email && { data_subject: data.email }),
      type,
      payload: rest,
    });

    return this.request(
      "/forms",
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: requestBody,
      },
      true
    );
  }
}
